import React, { useState, useEffect, useRef } from 'react'
import { convertToSentenceCase, convertToTitleCase } from '../../services/utils'
import { Button, Modal } from 'syngenta-react-components'
import { getCompaniesAdminDetail } from '../../services/apiHelper'
import HeaderFilter from '../../components/subComponents/HeaderFilter'
import TableStatus from '../../components/subComponents/TableStatus/TableStatus'
import Widget from '../../dpe-usco/components/Widget/Widget'
import { Table } from '../../dpe-usco'
import close from '../../assets/icons/close.svg'
import { generateExcel, generatePDF1 } from './GenerateDocument'
import CloseButton from '../../components/subComponents/CloseButton'
import { formatPhoneNumber } from '../../services/utils'

const CompanyAdminReport = () => {
  const [tableData, setTableData] = useState([])
  const [reportStatus, setReportStatus] = useState('LOADING')
  const [sortOrder, setSortOrder] = useState('asc')
  const [reportPdfUrl, setReportPdfUrl] = useState('')
  const [sortByKey, setSortByKey] = useState()
  const canceled = useRef(false)
  const [showModal, setShowModal] = useState(false)

  const customSort = (data, dataKey, sortBy) => {
    if (data?.length && dataKey) {
      setSortOrder(sortBy)
      setSortByKey(dataKey)
      let newTableData = []
      const getSafeString = val => (val ?? '').toString().toLowerCase()
      newTableData = [...data].sort((a, b) => {
        const aVal = getSafeString(a[dataKey])
        const bVal = getSafeString(b[dataKey])
        if (sortBy === 'asc') {
          return aVal > bVal ? 1 : -1
        } else {
          return aVal > bVal ? -1 : 1
        }
      })
      return newTableData
    }
    return data || []
  }

  const getAdminData = async () => {
    try {
      const res = await getCompaniesAdminDetail()
      if (res.data.items === 0) {
        setReportStatus('EMPTY')
        setTableData([])
      } else {
        setReportStatus('')
        setTableData(customSort(res.data.items, sortByKey, sortOrder))
      }
    } catch (err) {
      setReportStatus('ERROR')
    }
  }

  useEffect(() => {
    getAdminData()
    return () => {
      canceled.current = true
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const headerCell = (value, dataKey) => {
    const acendCallBack = () => {
      setSortOrder('asc')
      setSortByKey(dataKey)
      setTableData(customSort(tableData, dataKey, 'asc'))
    }

    const decendCallBack = () => {
      setSortOrder('desc')
      setSortByKey(dataKey)
      setTableData(customSort(tableData, dataKey, 'desc'))
    }

    return (
      <div key={value} className="cell df aic">
        <span>{value}</span>
        <HeaderFilter
          dataKey={dataKey}
          descend={() => decendCallBack()}
          ascend={() => acendCallBack()}
        />
      </div>
    )
  }
  const structure = {
    headers: [
      'Company Name',
      'SAP ID',
      'First Name',
      'Last Name',
      'Email',
      'Phone',
      'Company Type',
      'Enogen Dealer',
      'Role Name'
    ].map((header, index) => ({
      value: header,
      format: () => headerCell(header, structure.dataKeys[index])
    })),
    dataKeys: [
      'company_name',
      'sap_id',
      'first',
      'last',
      'email',
      'phone',
      'company_type',
      'enogen_dealer',
      'role_name'
    ],
    rowFormat: {
      company_name: {
        format: company_name => company_name
      },
      sap_id: {
        format: sap_id => sap_id
      },
      enogen_dealer: {
        format: type => (type ? 'TRUE' : 'FALSE')
      },
      company_type: {
        format: type => convertToSentenceCase(type)
      },
      first: {
        format: firstName => convertToTitleCase(firstName)
      },
      last: {
        format: lastName => convertToTitleCase(lastName)
      },
      phone: {
        format: phone => formatPhoneNumber(phone)
      },
      role_name: {
        format: reseller => convertToTitleCase(reseller)
      }
    }
  }

  const handleClose = () => {
    setShowModal(false)
  }

  // useEffect(() => {
  //   setReportPdfUrl('')
  //   generatePDF('.table','Company Admin Report').then(res => setReportPdfUrl(res))
  // }, [tableData])
  useEffect(() => {
    setReportPdfUrl('')
    const header = 'Company Admin Report'
    const pdf = generatePDF1(tableData, structure, header)
    setReportPdfUrl(pdf)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showModal, tableData])

  const callToDownloadExlSheet = () => {
    // define table structure
    const table = '.table'
    const header = '.tableHeader > div'
    const body = '.tableBody > div'
    generateExcel(table, header, body)
  }
  const renderButtonRow = (
    <div className="pdf-btn">
      <Button
        onClick={callToDownloadExlSheet}
        customClassName="mr10"
        backgroundColor={'#238661'}
        textColor={'#FFFFFF'}
        disabled={tableData.length === 0}
        text="Download as Excel"
      />
      <Button
        onClick={e => setShowModal(true)}
        customClassName="mr10"
        backgroundColor={'#238661'}
        textColor={'#FFFFFF'}
        disabled={tableData.length === 0}
        text="Download as PDF"
      />
    </div>
  )

  return (
    <>
      <div className="m25">
        <div className="mb50">
          <Widget title={'Company Admin Report'} button={renderButtonRow}>
            <div className="mb20 mt20">
              {tableData && (
                <Table
                  structure={structure}
                  data={tableData}
                  statusComponent={
                    reportStatus ? (
                      <TableStatus status={reportStatus} prompt="No data" />
                    ) : null
                  }
                />
              )}
            </div>
          </Widget>
        </div>
      </div>
      <Modal autoHeight show={showModal} handleClose={handleClose}>
        <div
          className="modalContainer"
          style={{
            display: showModal ? 'block' : 'none',
            backgroundColor: 'rgba(0, 0, 0, 1%'
          }}
        >
          <div
            className="aHModalChild posr t100"
            style={{ maxWidth: '1200px' }}
          >
            <div className="modalStyle w100% tal h100% bgc-white bd1-s-lightgray bxshmodal bdrs-4 mb40">
              <div className="cancelDiv">
                <div>Company Admin Report</div>
                <CloseButton
                  closeAction={handleClose}
                  src={close}
                />
              </div>
              {reportPdfUrl && (
                <object
                  data={reportPdfUrl}
                  type="application/pdf"
                  className="pdf-container"
                >
                  <p>This browser does not support PDFs.</p>
                </object>
              )}
            </div>
          </div>
        </div>
      </Modal>
    </>
  )
}

export default CompanyAdminReport
